import {
    RELOAD_THEMES,
    ThemesAction,
    ThemeSettings,
    ThemesState
} from "./types";
import ThemesAPI from "../../api/themes";
import { defaultTheme, defaultThemeSettings } from "../../settings/themes";
import { createTheme } from "@mui/material";

// ------ STATE ------ //

const initialState: ThemesState = {
    default: defaultTheme
}

// ----- REDUCER ----- //

export default function themesReducer(state = initialState, action: ThemesAction) : ThemesState
{
    switch(action.type)
    {
        case RELOAD_THEMES:
            return reloadThemes(state, action.themes);
        default:
            return state;
    }
}

// ----- ACTIONS ----- //

function reloadThemes(state: ThemesState, themeSettings: ThemeSettings) : ThemesState
{
    return {
        ...state,
        ...createThemes(themeSettings)
    };
}

export function loadThemes(oldThemesState: ThemesState)
{
    return ThemesAPI.getThemes().then((themeSettings: ThemeSettings) => {
        return {
            ...oldThemesState,
            ...createThemes(themeSettings)
        }
    }).catch(err=>{
        return {
            ...oldThemesState
        }
    });
}

export function createThemes(themeSettings: ThemeSettings): ThemesState
{
    let themesState: ThemesState = {};
    let keys = Object.keys(themeSettings);
    for(let i = 0; i < keys.length; i++)
    {
        const theme = {
            ...createTheme({
                ...defaultThemeSettings.mui,
                ...themeSettings[keys[i]].mui
            }),
            ...defaultThemeSettings.settings,
            ...themeSettings[keys[i]].settings,
            css: {
                ...defaultThemeSettings.css,
                ...themeSettings[keys[i]].css
            }
        };
        themesState = {
            ...themesState,
            [keys[i]]: theme
        };
    }

    return themesState;
}

// -------------------- //